import { API } from '../api'
import { crmServiceUrl } from '../utils/constants'

export const fetchOpportunityDetailsAPI = (
  crmId: string,
  crmObjectName: string,
  parentObjectId: string
) =>
  API.get(`${crmServiceUrl}/crms/${crmId}/salesforce/opportunities`, {
    params: {
      crm_object_name: crmObjectName,
      parent_object_id: parentObjectId,
    },
  })

export const fetchOpportunitiesDetailsAPI = (
  crmId: string,
  crmObjectName: string,
  parentObjectId: string[]
) =>
  API.get(`${crmServiceUrl}/crms/${crmId}/salesforce/opportunities/details`, {
    params: {
      crm_object_name: crmObjectName,
      parent_object_id: parentObjectId,
    },
    paramsSerializer: params => {
      return Object.entries(params)
        .reduce((acc, [key, value]) => {
          const encodedKey = encodeURIComponent(key)
          if (Array.isArray(value)) {
            const encodedValues = value.map(v => encodeURIComponent(String(v)))
            acc.push(`${encodedKey}=[${encodedValues.join(',')}]`)
          } else {
            acc.push(`${encodedKey}=${encodeURIComponent(String(value))}`)
          }
          return acc
        }, [] as string[])
        .join('&')
    },
  })

export const getRecordByRecordId = (
  crmId: string,
  crmObjectName: string,
  recordId: string,
  fields?: string
) =>
  API.get(`${crmServiceUrl}/crms/${crmId}/${crmObjectName}/${recordId}`, {
    ...(fields != null && fields !== '' && { params: { fields } }),
  })

export const fetchCrmObjectLinks = (crmId: string, ids: string[]) =>
  API.get<Record<string, string>>(
    `${crmServiceUrl}/crms/${crmId}/object_links`,
    {
      params: {
        ids: ids.join(','),
      },
    }
  )
